"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Product = /** @class */ (function () {
    function Product(productID) {
        this.name = '';
        this.isGift = false;
        this.set = 'none';
        this.category = '';
        this.category1 = '';
        this.category2 = '';
        this.category3 = '';
        this.range = '';
        this.referenceWrapper = '';
        this.unitPrice = 0;
        this.basePrice = 0;
        this.discountPercentage = '';
        this.currency = '';
        this.ratings = 0;
        this.nbBVreviews = '0';
        this.inStock = 'in stock';
        this.sticker1 = '';
        this.sticker2 = '';
        this.color = '';
        this.t2s = 'false';
        this.productID = productID;
    }
    return Product;
}());
exports.default = Product;
